import { defineAbility } from '@casl/ability';
import {
  ROLE_BRANCH_ADMIN,
  ROLE_BRANCH_STAFF,
  ROLE_ORGANIZATION_ADMIN,
  ROLE_GROUND_TEAM,
  ROLE_GROUNDS_TEAM_MANAGER
} from 'context/authContext';
import { permissionsKeyMap } from './permissionKeys';

export default function defineAbilityFor(role, permissions) {
  return defineAbility((can, cannot) => {
    if (!role) return;
    can('manage', permissionsKeyMap.settings.children.personal);
    if (role === ROLE_ORGANIZATION_ADMIN) {
      can('manage', 'all');
    } else if (role === ROLE_BRANCH_ADMIN) {
      can('manage', 'all');
      // Branch admins cannot manage organization-level settings
      cannot('manage', permissionsKeyMap.settings.children.organizationDetails);
      // Branch admins CAN manage branch-specific settings
      // Removed restrictions for: branches, smtp, users, payment, donationSettings, sponsorshipValues (now branch-level)
    } else if (
      role === ROLE_BRANCH_STAFF ||
      role === ROLE_GROUND_TEAM ||
      // Grounds Team Manager previously fell through every branch and got no
      // ability at all - "no pages" after login. Managers are permissions-
      // driven exactly like staff/ground team; their extra grants live in the
      // role's permission JSON.
      role === ROLE_GROUNDS_TEAM_MANAGER
    ) {
      // Handle permissions whether they are already parsed objects or JSON strings
      let parsedPermissions = {};
      if (permissions) {
        if (typeof permissions === 'string') {
          try {
            parsedPermissions = JSON.parse(permissions);
          } catch (e) {
            console.error('Failed to parse permissions:', e);
            parsedPermissions = {};
          }
        } else if (typeof permissions === 'object') {
          parsedPermissions = permissions;
        }
      }
      cannot(
        'manage',
        permissionsKeyMap.sponsorship.children.sponsorshipValues
      );
      cannot('manage', permissionsKeyMap.donation.children.donationSettings);
      Object.entries(parsedPermissions).forEach(([subjectKey, actions]) => {
        Object.entries(actions)
          // eslint-disable-next-line no-unused-vars
          .filter(([_, value]) => value)
          .forEach(([actionKey]) => {
            can(actionKey, subjectKey);
          });
      });
    }
  });
}
